<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import {
  add,
  getZajiMapping,
  getDetails,
  update,
  del,
} from "@/api/system/zaji";
import { getCity } from "@/api/system/city";
import { getCountry } from "@/api/system/country";
import cTable from "@/base/common/index";
export default {
  name: "convert",
  components: {
    cTable,
  },

  async mounted() {},
  methods: {},
  data() {
    return {
      methods: {
        list: getZajiMapping,
        add,
        getDetails,
        update,
        del,
        getCity,
        getCountry,
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods(row.id ? "update" : "add", row, true)
                .then(() => {
                  this.$page.getList();
                  close();
                });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: "40%",
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              zajil_city_name: [
                {
                  required: true,
                  trigger: "blur",
                },
                {
                  max: 155,
                  message: "Maximum length 55",
                  trigger: "blur",
                },
              ],
              zajil_city_code: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
              country_id: [
                {
                  required: true,
                  type: "number",
                  trigger: "change",
                },
              ],
              vnlin_city_id: [
                {
                  required: true,
                  type: "number",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            { zajil_city_name: 24 },
            { zajil_city_code: 24 },
            { country_id: 24 },
            { vnlin_city_id: 24 },
          ],
          fields: [
            {
              key: "zajil_city_name",
              name: () => "ZaJil" + this.$t("city_name"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("city_mapping");
              },
            },
            {
              key: "zajil_city_code",
              name: () => "ZaJil" + this.$t("city_code"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("city_code");
              },
            },
            {
              key: "country_id",
              name: () => this.$t("countryName"),
              component: "Select",
              options: [],
              disabled: true,
              config: {
                label({ row }) {
                  return row.title + "(" + row.code + ")";
                },
                value: "id",
              },
              default: 12,
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCountry", {
                      keywords: "SA",
                    })
                  ).payload.rows;
                  this.$forceUpdate();
                },
              },
            },
            {
              key: "vnlin_city_id",
              name: () => "Vnlin" + this.$t("city_name"),
              component: "Select",
              config: {
                label: "title",
                value: "id",
              },
              placeholder() {
                return this.$t("select") + this.$t("city_name");
              },
              options: [],
              methods: {
                async list({ field, formData }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCity", {
                      country_id: formData.country_id,
                    })
                  ).payload.rows;
                  this.$forceUpdate();
                },
              },
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "addFun",
              bind: {
                type: "warning",
                icon: "md-add",
              },
              id: 969,
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "exportFun",
              bind: {
                type: "success",
                icon: "md-download",
              },
              disabled(row) {
                return !this.selectAll.length;
              },
            },
          ],
          methods: {
            addFun() {
              this.getModal("add").open({}, function () {
                this.setTitle(this.$t("add"));
              });
            },
            exportFun({ field, searchForm }) {
              this.exportExc();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left",
          show: false,
        },
        {
          name: () => "ZaJil" + this.$t("city_name"),
          key: "zajil_city_name",
          align: "left",
        },
        {
          name: () => "ZaJil" + this.$t("city_code"),
          key: "zajil_city_code",
          align: "left",
        },
        {
          name: () => "Vnlin" + this.$t("city_name"),
          key: "vnlin_city_name",
          align: "left",
        },
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success",
              },
              id: 968,
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error",
              },
              id: 967,
            },
          ],

          methods: {
            async updateFun({ row }) {
              let res = await this.handleRequestMethods("getDetails", row.id);
              this.getModal("add").open(res.payload, function () {
                this.setTitle(this.$t("update"));
              });
            },
            async operationFun({ row }) {
              this.getModal("operation").open(
                {
                  packageId: row.id,
                },
                function () {
                  this.setTitle(this.$t("operation"));
                }
              );
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") + this.$t("confirm") + this.$t("delete"),
                content:
                  "Zajil" +
                  this.$t("city_name") +
                  ":" +
                  row.zajil_city_name +
                  "?",
                onOk: () => {
                  this.handleRequestMethods("del", row.id, true).then(() => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
